<template>
  <div class="suitComponent" :class="{ noColor }">
    <fa :icon="icon" :class="suit" :size="size" />
  </div>
</template>

<script>
export default {
  name: "Suit",
  props: {
    suit: { type: String, required: true },
    noColor: { type: Boolean, default: false },
    size: { type: String, default: "sm" },
  },
  computed: {
    icon() {
      const icons = {
        h: "heart",
        s: "spade",
        d: "diamond",
        c: "club",
      };
      return !this.outlineOnly ? icons[this.suit] : ["fas", icons[this.suit]];
    },
  },
};
</script>

<style lang="scss" scoped>
.h,
.d {
  color: red;
}
.s,
.c {
  color: black;
}
.noColor {
  .h,
  .d,
  .s,
  .c {
    color: inherit;
  }
}
</style>
